
<span
  v-if="price"
  class="cmp-price-cell ws-text-secondary ws-text-level-up ws-typography ws-typo-xs"
>
  <!-- OLD PRICE -->
  <span
    v-if="hasMarketingPrice && !transfer"
    class="old-price line-through inline-block"
  >{{ $n(unifiedPrice.marketingPrice, 'currency') }}</span>

  <!-- ACTUAL PRICE -->
  <small :class="{ 'q-ml-sm': hasMarketingPrice }"><strong class="current-price ws-text-primary">{{
    $n(
      (transfer ? unifiedPrice.transferPrice : unifiedPrice.actualPrice) ||
        0,
      'currency'
    )
  }}</strong></small>

  <!-- PERIOD -->
  <span v-if="showPeriod" class="period q-mr-sm">&nbsp;/{{ calcPeriod }}</span>

  <!-- PROLONG PRICE -->
  <div
    v-if="hasProlongPrice"
    class="prolong-price q-mr-sm"
  >
    <span>{{ calcProlongPeriod }}&nbsp;{{
      $n(unifiedPrice.prolongPrice, 'currency')
    }}&nbsp;</span>
    <ws-icon name="info" :size="14" />
    <ws-tooltip placement="bottom">
      {{ $t('cart.prolong_price_hint') }}
    </ws-tooltip>
  </div>
</span>
